import { render, staticRenderFns } from "./VersionApp.vue?vue&type=template&id=6bc75ff8&scoped=true"
import script from "./VersionApp.vue?vue&type=script&lang=js"
export * from "./VersionApp.vue?vue&type=script&lang=js"
import style0 from "./VersionApp.vue?vue&type=style&index=0&id=6bc75ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc75ff8",
  null
  
)

export default component.exports